import React from "react";
import "hammerjs";
import * as kc from "@progress/kendo-react-charts";
import "@progress/kendo-theme-material/dist/all.css";
import { getDefaults } from "./chartUtilities";

export const RadarChart = ({ dataSet, def, type }) => {
	const defaults = getDefaults("colours");

	if (dataSet === null || !dataSet.data || def === null) {
		return (
			<>
				<h2>Loading</h2>
			</>
		);
	} else {
		const categories = def.format.data.map((e) => e.display);

		const sortedItems = dataSet.data.slice().sort((a, b) => {
			return categories.indexOf(a.name) - categories.indexOf(b.name);
		});

		const axes = def.format.axes
			.filter((e) => e.type === "radial" || e.type === "y")
			.map((e, index) => {
				return (
					<kc.ChartValueAxisItem
						key={e.name ?? `axis${1}`}
						min={e.min ?? 0}
						max={e.max ?? 10}
						type="numeric"
						majorUnit={e.units ?? 1}
						visible={false}
					/>
				);
			});

		const colours = def.format.colours ?? {};

		return (
			<>
				<kc.Chart className={"h-full w-full"}>
					<kc.ChartAxisDefaults
						majorGridLines={{
							color: colours.gridLine ?? defaults.gridLine,
							width: 1,
						}}
					/>
					<kc.ChartArea opacity={0} />

					<kc.ChartCategoryAxis>
						<kc.ChartCategoryAxisItem
							categories={categories}
							labels={{
								color: colours.label ?? defaults.label,
								rotation: "auto",
							}}
						/>
					</kc.ChartCategoryAxis>
					<kc.ChartSeries>
						<kc.ChartSeriesItem
							type={type ?? "radarArea"}
							data={sortedItems ?? []}
							field="value"
							color={`${colours.area || defaults.radarChart.area}`}
							opacity={0.5}
						/>
					</kc.ChartSeries>

					<kc.ChartValueAxis>{axes}</kc.ChartValueAxis>
				</kc.Chart>
			</>
		);
	}
};
